import {useState} from 'react'
import GoodIssueDetailList from './goodIssueDetailList';

const GoodIssueDetail = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");
return (
  <>
    <GoodIssueDetailList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
  </>
  )
}

export default GoodIssueDetail

